import { useState, useEffect } from "react";

const Timer = ({
  seconds = 30
}) => {
  const [count, setCount] = useState(seconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev === 2) {
          return prev + 10; // add 10 seconds when 2s is reached
        }
        if (prev <= 1) {
          clearInterval(interval); // stop timer when it reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="">
      ({count})s
    </div>
  );
};

export default Timer;
